var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-box"},[_c('el-card',{staticClass:"wrap-card",attrs:{"shadow":"never","body-style":{height: '100%',padding:_vm.Padding}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }